<template>
  <div class="plan-complete mt-6">
    <div id="message" class="m-4 text-center">
      <h2 class="text-2xl font-semibold leading-snug">
        <span class="block text-link">お気に入り登録</span>
        <span class="block">が出来るようになりました</span>
      </h2>
    </div>

    <div v-if="true" id="message" class="m-4 text-center">
      <h2 class="text-2xl font-semibold leading-snug">
        <span class="block">リカバリーコード</span>
        <span class="block text-link">{{ recoveryCode }}</span>
        <span class="block text-sm">リカバリーコードのメモをオススメします。もしプランが消えてしまっても復元することができます。</span>
      </h2>
    </div>

    <div class="px-4">
      <a :href="questionnaire_url()" class="button-secondary w-full block button-icon icon-right" target="_blank">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
        <span>アンケートにご協力ください</span>
      </a>
    </div>

    <div id="control" class="mt-4 py-4 bg-light_gray border-t border-b border-section_border">
      <div class="mt-4 px-4">
        <a class="button-secondary w-full block button-icon icon-left" @click="back">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>{{ $t('back_to_top') }}</span>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
import router from '../router'
import Constants from '../constants'

export default {
  name: 'Registered',
  data () {
    return {
      id: this.$route.params.planId,
      tickets: []
    }
  },
  methods: {
    back: function () {
      router.push({ path: '/plans' })
    },
    show: function () {
      router.push({ name: 'plan', params: { id: this.id } })
    },
    questionnaire_url: function () {
      return Constants.QUESTIONNAIRE_URL
    }
  },
  computed: {
    recoveryCode: function () {
      return this.$store.getters['user/getRecoveryCode']
    }
  }
}
</script>
